export enum FilterComponent {
  audits = 'audits',
  findings = 'findings',
  dashboard = 'dashboard'
}
